// Coffee Noir: la preferencia vive en personas.preferencias.tema y se aplica en el navegador
// con la clase "dark" y la clave que lee AppShell (iavmx.tema). "sistema" borra la clave.
import { EVENTO_TEMA } from "@iavmx/ui";

export type Tema = "claro" | "oscuro" | "sistema";

export function aplicarTema(tema: Tema) {
  try {
    if (tema === "sistema") localStorage.removeItem("iavmx.tema");
    else localStorage.setItem("iavmx.tema", tema);
  } catch {
    /* sin almacenamiento */
  }
  const oscuro =
    tema === "oscuro" ||
    (tema === "sistema" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", oscuro);
  window.dispatchEvent(new Event(EVENTO_TEMA));
}

/** Lee el tema guardado en preferencias, si es válido. */
export function temaDePreferencias(preferencias: Record<string, unknown> | null | undefined): Tema | null {
  const t = preferencias?.tema;
  return t === "claro" || t === "oscuro" || t === "sistema" ? t : null;
}
